import api from '@pray/shared/utils/api';

type UpdateBookProps = {
  artistId: string;
  bookId: string;
  title?: string;
  description?: string;
  imageUrl?: string;
  coverFile?: File | null;
  externalUrl?: string;
};

export const updateBook = async ({ artistId, bookId, title, description, imageUrl, externalUrl }: UpdateBookProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!bookId) throw Error('Book ID is required');

  const url = `/web/studio/artists/${artistId}/books/${bookId}`;

  const data = {
    ...(title ? { title } : {}),
    ...(description ? { description } : {}),
    ...(imageUrl ? { image_url: imageUrl } : {}),
    // External URLs must have a valid link or be null to be updated
    external_url: externalUrl || null,
  };

  await api.executePutRequest(url, data);
};
